import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { id: 'component.connectedapps.title', defaultMessage: 'Connected apps' },
  intro: {
    id: 'component.connectedapps.intro',
    defaultMessage:
      'Apps you signed in to FileSpin with. Signing one out cuts it off straight away; it has to ask you to sign in again.',
  },
  loading: { id: 'component.connectedapps.loading', defaultMessage: 'Loading connected apps…' },
  loadError: {
    id: 'component.connectedapps.loaderror',
    defaultMessage: "Couldn't load connected apps. Try again in a moment.",
  },
  forbidden: {
    id: 'component.connectedapps.forbidden',
    defaultMessage: "You don't have permission to see these connected apps.",
  },
  emptySelf: {
    id: 'component.connectedapps.emptyself',
    defaultMessage:
      'No apps are connected. Connect Claude, ChatGPT or another AI assistant by adding {url} as a connector, then sign in when it asks.',
  },
  emptyUser: { id: 'component.connectedapps.emptyuser', defaultMessage: 'This member has no connected apps.' },
  emptyAccount: { id: 'component.connectedapps.emptyaccount', defaultMessage: 'No apps are connected to this account.' },
  emptyFiltered: { id: 'component.connectedapps.emptyfiltered', defaultMessage: 'No connected apps match these filters.' },
  allUsers: { id: 'component.connectedapps.allusers', defaultMessage: 'All users' },
  allApps: { id: 'component.connectedapps.allapps', defaultMessage: 'All apps' },
  filterUser: { id: 'component.connectedapps.filteruser', defaultMessage: 'User' },
  filterApp: { id: 'component.connectedapps.filterapp', defaultMessage: 'App' },

  connected: { id: 'component.connectedapps.connected', defaultMessage: 'Connected {date}' },
  lastUsed: { id: 'component.connectedapps.lastused', defaultMessage: 'last used {when}' },
  notUsed: { id: 'component.connectedapps.notused', defaultMessage: 'not used yet' },
  via: { id: 'component.connectedapps.via', defaultMessage: '{name} via {client}' },
  runsSchedules: {
    id: 'component.connectedapps.runsschedules',
    defaultMessage: '{count, plural, one {Runs # scheduled agent} other {Runs # scheduled agents}}',
  },

  viewActivity: { id: 'component.connectedapps.viewactivity', defaultMessage: 'View activity' },
  rename: { id: 'component.connectedapps.rename', defaultMessage: 'Rename' },
  renameLabel: { id: 'component.connectedapps.renamelabel', defaultMessage: 'Name' },
  renameHint: {
    id: 'component.connectedapps.renamehint',
    defaultMessage: 'Leave empty to show the app’s own name.',
  },
  save: { id: 'component.connectedapps.save', defaultMessage: 'Save' },
  cancel: { id: 'component.connectedapps.cancel', defaultMessage: 'Cancel' },
  renamed: { id: 'component.connectedapps.renamed', defaultMessage: 'Name saved' },

  signOut: { id: 'component.connectedapps.signout', defaultMessage: 'Sign out' },
  signOutConfirm: {
    id: 'component.connectedapps.signoutconfirm',
    defaultMessage: 'Sign out {name}? It will need to sign in again to reach FileSpin.',
  },
  signOutSchedulesConfirm: {
    id: 'component.connectedapps.signoutschedulesconfirm',
    defaultMessage:
      'This connection runs the scheduled agents below. Signing it out stops them until they are re-authorised on the Scheduled agents page.',
  },
  signOutAndStop: { id: 'component.connectedapps.signoutandstop', defaultMessage: 'Sign out and stop schedules' },
  signedOut: { id: 'component.connectedapps.signedout', defaultMessage: '{name} signed out' },

  signOutAll: { id: 'component.connectedapps.signoutall', defaultMessage: 'Sign out all' },
  signOutAllConfirm: {
    id: 'component.connectedapps.signoutallconfirm',
    defaultMessage: '{count, plural, one {Sign out # app?} other {Sign out all # apps?}} Each will need to sign in again.',
  },
  signOutAllKeepsSchedules: {
    id: 'component.connectedapps.signoutallkeepsschedules',
    defaultMessage: 'The connection that runs scheduled agents is kept.',
  },
  alsoStopSchedules: {
    id: 'component.connectedapps.alsostopschedules',
    defaultMessage: 'Also sign out scheduled agents',
  },
  signedOutAll: {
    id: 'component.connectedapps.signedoutall',
    defaultMessage:
      '{revoked, plural, =0 {Nothing to sign out} one {Signed out # app} other {Signed out # apps}}{kept, plural, =0 {} other {. Kept the scheduled agents connection}}',
  },
  actionFailed: {
    id: 'component.connectedapps.actionfailed',
    defaultMessage: "That didn't work. Refresh and try again.",
  },
  appsCount: {
    id: 'component.connectedapps.appscount',
    defaultMessage: '{count, plural, =0 {None} one {# app} other {# apps}}',
  },
  modalTitleUser: { id: 'component.connectedapps.modaltitleuser', defaultMessage: 'Connected apps of {email}' },
  modalTitleAccount: { id: 'component.connectedapps.modaltitleaccount', defaultMessage: 'Connected apps in this account' },
  availableHeading: {
    id: 'component.connectedapps.availableheading',
    defaultMessage: 'Not connected yet',
  },
  availableDescription: {
    id: 'component.connectedapps.availabledescription',
    defaultMessage: 'Search, tag and share your FileSpin assets from {agent}.',
  },
  connect: {
    id: 'component.connectedapps.connect',
    defaultMessage: 'Connect',
  },
});

/** Plain-English names for OAuth2 scopes; unknown scopes show as sent. */
export const scopeLabels: Record<string, string> = {
  read_assets: 'View assets',
  write_assets: 'Upload and edit assets',
  manage_collections: 'Manage collections',
  manage_schedules: 'Run scheduled agents',
  send_notifications: 'Send notifications',
  read_stats: 'View usage statistics',
};
